import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  lcGroupIconSvg,
  lcOrientationIconSvg,
  lcP2lIconSvg,
  lcPrivateIconSvg,
} from '../assets/images';
import { mt } from '../style-utils';

export interface LiveClassTagProps {
  type?: LiveClassType;
}

export type LiveClassType = 'gameclass' | 'group' | 'private' | 'orientation';

export const LiveClassTag: React.FC<LiveClassTagProps> = ({ type = 'group' }) => {
  const __ = useTranslation().t;
  const LCIcon = useCallback(() => {
    switch (type) {
      case 'gameclass':
        return <img src={lcP2lIconSvg} alt={type} style={mt(-3)} />;
      case 'private':
        return <img src={lcPrivateIconSvg} alt={type} style={mt(-1)} />;
      case 'orientation':
        return <img src={lcOrientationIconSvg} alt={type} style={mt(-1)} />;
      case 'group':
      default:
        return <img src={lcGroupIconSvg} alt={type} style={mt(-1)} />;
    }
  }, [type]);

  const renderText = () => {
    switch (type) {
      case 'gameclass':
        return __('play2Learn');
      case 'private':
        return __('privateClass');
      case 'orientation':
        return __('platformTour');
      case 'group':
      default:
        return __('groupClass');
    }
  };

  return (
    <Container type={type}>
      <StyledIcon>
        <LCIcon />
      </StyledIcon>
      <StyledText>{renderText()}</StyledText>
    </Container>
  );
};

interface ContainerProps {
  type: LiveClassType;
}

const Container = styled.div<ContainerProps>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 8px;
  border-radius: 4px;
  ${({ type, theme }) => {
    switch (type) {
      case 'gameclass':
        return `
          background: rgba(255, 133, 51, 0.06);
          color: ${theme.colors.orange};
        `;
      case 'private':
        return `
          background: ${theme.colors.greenBackground};
          color: ${theme.colors.greenDark};  
        `;
      case 'orientation':
        return `
          background: ${theme.colors.redBackground};
          color: ${theme.colors.redDark};
        `;
      case 'group':
      default:
        return `
          background: ${theme.colors.backgroundSuperLight};
          color: ${theme.colors.blue};
        `;
    }
  }};
`;

const StyledIcon = styled.div`
  margin-right: 4px;
  font-size: 14px;
`;

const StyledText = styled.div`
  font-family: 'Baloo 2';
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;
